const initialState = {
  modal_customer_transaction_game: {
    data: [],
    total: -1
  },
  modal_customer_transaction_game_winloss: {
    data: [],
    total: -1
  },
  modal_customer_transaction_game_ticket: {
    data: [],
    total: -1
  },
  modal_customer_transaction_game_wheel: {
    data: [],
    total: -1
  },
  modal_customer_activity: {
    data: [],
    total: -1
  },
  modal_customer_transaction_credit: {
    data: [],
    total: -1
  },
  modal_customer_invite_friend: {
    data: [],
    total: -1
  },
  modal_customer_number: {
    data: [],
    total: -1
  },
  modal_customer_commission_list: {
    data: [],
    total: -1
  },
  modal_customer_friend_summary: {
    data: [],
    total: -1
  },
  modal_customer_promotion: {
    data: [],
    total: -1
  },
  modal_customer_ip_history: {
    data: [],
    total: -1
  },
  modal_customer_shop: {
    data: [],
    total: -1
  },
  modal_customer_wallets: {
    data: [],
    total: -1
  },
  modal_customer_banks: {
    data: [],
    total: -1,
    log: []
  },
  organization_agentbank_payment_711_list: {
    data: [],
    total: -1,
    params: {}
  },
  organization_sub_history: {
    data: [],
    total: -1,
    log: []
  },
  organization_follow: {
    data: [],
    total: -1,
    log: []
  },
  //payment
  bank_bot_list: {
    data: [],
    total: -1,
    params: {}
  },
  deposit_list: {
    data: [],
    total: -1,  
    params: {}
  },
  withdraw_list: {
    data: [],
    total: -1,
    params: {}
  },
  topup_list: {
    data: [],
    total: -1,
    params: {}
  },
  organization_agentbank_list: {
    data: [],
    total: -1,
    params: {}
  },
  organization_agentbank_transaction_list: {
    data: [],
    total: -1,
    params: {}
  },
  organization_agentbank_channel_list: {
    data: [],
    total: -1,
    params: {}
  },
  financial_summary_list: {
    data: [],
    total: -1,
    params: {}
  },
  financial_summary_fee: {
    data: [],
    total: -1,
    params: {}
  },
  financial_bank_result: {
    data: [],
    total: -1,
    params: {}
  },
  financial_payment_gateway_result: {
    data: [],
    total: -1,
    params: {}
  },
  financial_payment_gateway_manual_result: {
    data: [],
    total: -1,
    params: {}
  },
  financial_compare_list: {
    data: [],
    total: -1,
    params: {}
  },
  financial_transfer_list: {
    data: [],
    total: -1,
    params: {}
  },
  financial_modal_list: {
    data: [],
    total: -1,
    params: {}
  },
  financial_detail_list: {
    data: [],
    total: -1,
    params: {}
  },

  //customer
  customer_list: {
    data: [],
    total: -1,
    params: {}
  },
  category_list: {
    data: [],
    total: -1,
    params: {}
  },
  affiliate_list: {
    data: [],
    total: -1,
    params: {}
  },
  agent_social_list: {
    data: [],
    total: -1,
    params: {}
  },
  ai_agent_skill_list: {
    data: [],
    total: -1,
    params: {}
  },
  ai_agent_blessing_message_list: {
    data: [],
    total: -1,
    params: {}
  },
  ai_agent_incident_list: {
    data: [],
    total: -1,
    params: {}
  },
  ai_agent_handoff_list: {
    data: [],
    total: -1,
    params: {}
  },
  ai_agent_mcp_server_list: {
    data: [],
    total: -1,
    params: {}
  },
  chat_bot_list: {
    data: [],
    total: -1,
    params: {}
  },
  chat_bot_ticket_list: {
    data: [],
    total: -1,
    params: {}
  },
  chat_bot_group_list: {
    data: [],
    total: -1,
    params: {}
  },
  chat_bot_history_list: {
    data: [],
    total: -1,
    params: {}
  },
  organization_sub_list: {
    data: [],
    total: -1,
    params: {}
  },
  //report
  win_loss_list: {
    data: [],
    total: -1,
    params: {}
  },
  win_loss_game_list: {
    data: [],
    total: -1,
    params: {}
  },
  win_loss_customer_list: {
    data: [],
    total: -1,
    params: {}
  },
  commission_list: {
    data: [],
    total: -1,
    params: {}
  },
  commission_category_list: {
    data: [],
    total: -1,
    params: {}
  },
  cashback_list: {
    data: [],
    total: -1,
    params: {}
  },
  cashback_category_list: {
    data: [],
    total: -1,
    params: {}
  },
  game_cmap_list: {
    data: [],
    total: -1,
    params: {}
  },
  deposit_again_list: {
    data: [],
    total: -1,
    params: {}
  },
  customer_referral_summary: {
    data: [],
    total: -1,
    params: {}
  },
  customer_disappear: {
    data: [],
    total: -1,
    params: {}
  },
  organization_agent_credit_transaction: {
    data: [],
    total: -1,
    params: {}
  },
  marketing_report_referral: {
    data: [],
    total: -1,
    params: {}
  },
  marketing_report_summary_referral: {
    data: [],
    total: -1,
    params: {}
  },
  report_activity_apply: {
    data: [],
    total: -1,
    params: {}
  },
  //setting
  setting_role_list: {
    data: [],
    total: -1,
    params: {}
  },
  game_list: {
    data: [],
    total: -1,
    params: {}
  },
  image_game_list: {
    data: [],
    total: -1,
    params: {}
  },
  banner_slide_list: {
    data: [],
    total: -1,
    params: {}
  },
  banner_slide_event_list: {
    data: [],
    total: -1,
    params: {}
  },
  banner_slide_hot_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_contact_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_agent_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_agent_cms_list: {
    data: [],
    total: -1,
    params: {}
  },
  mission_wheel_list: {
    data: [],
    total: -1,
    params: {}
  },
  campaign_list: {
    data: [],
    total: -1,
    params: {}
  },
  campaign_customer_list: {
    data: [],
    total: -1,
    params: {}
  },
  event_activity_list: {
    data: [],
    total: -1,
    params: {}
  },
  event_activity_choose_list: {
    data: [],
    total: -1,
    params: {}
  },
  event_activity_reward_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_category_withdraw_list: {
    data: [],
    total: -1,
    params: {}
  },

  //promotion
  promotion_apply_list: {
    data: [],
    total: -1,
    params: {}
  },
  //lottery
  lottery_ticket: {
    data: [],
    total: -1,
    params: {}
  },
  lottery_ticket_number: {
    data: [],
    total: -1,
    params: {}
  },
  lottery_ticket_history: {
    data: [],
    total: -1,
    params: {}
  },
  lottery_round_result: {
    data: [],
    total: -1,
    params: {}
  },
  //marketing
  transfer_customer: {
    data: [],
    total: -1,
    params: {}
  },
  customer_referral_summary: {
    data: [],
    total: -1,
    params: {}
  },
  marketing_referral_customer_list: {
    data: [],
    total: -1,
    params: {}
  },
  marketing_referral_member_list: {
    data: [],
    total: -1,
    params: {}
  },
  transaction_analyze_list: {
    data: [],
    total: -1,
    params: {}
  },
  marketing_tracking_list: {
    data: [],
    total: -1,
    params: {}
  },
  transaction_credit_list: {
    data: [],
    total: -1,
    params: {}
  },
  agent_payment_gate_score_list: {
    data: [],
    total: -1,
    params: {}
  },
  agent_billing_table: {
    data: [],
    total: -1,
    params: {}
  },
  setting_pgscore_weight_list: {
    data: [],
    total: -1,
    params: {}
  },
  agent_bank_wallet_account: {
    data: [],
    total: -1,
    params: {}
  },
  cronjob_list: {
    data: [],
    total: -1,
    params: {}
  },
  //hero
  hero_admin_lottery_round_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_default_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_ticket_number: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_special_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_unlimit_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_special_list_round: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_price: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_winloss: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_bigwin: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_result_number: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_unlimit_number: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_transaction: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_result_user: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_price_customer_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_report_result_lottery_type: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_setting_review: {
    data: [],
    total: -1,
    params: {}
  },
  customer_online: {
    data: [],
    total: -1,
    params: {}
  },
  game_analysis: {
    data: [],
    total: -1,
    params: {}
  },
  profitloss_report: {
    data: [],
    total: -1,
    params: {}
  },
  setting_agent_cms_gametype_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_agent_cms_menu_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_sms_template_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_sms_list: {
    data: [],
    total: -1,
    params: {}
  },
  setting_sms_history_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_round_risk_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_round_risk_list: {
    data: [],
    total: -1,
    params: {}
  },
  hero_admin_lottery_bugget_rate_list: {
    data: [],
    total: -1,
    params: {}
  },
  analyze_promotion_apply: {
    data: [],
    total: -1,
    summary: {},
    params: {}
  },
  domain_registration_list: {
    data: [],
    total: -1,
    summary: {},
    params: {}
  },
  agent_infrastructure_list: {
    data: [],
    total: -1,
    summary: {},
    params: {}
  },
  lottery_short_list: {
    data: [],
    total: -1,
    params: {}
  },
  lottery_type_short_list: {
    data: [],
    total: -1,
    params: {}
  },
  lottery_cronjob_list: {
    data: [],
    total: -1,
    params: {}
  },
  partner_level_list: {
    data: [],
    total: -1,
    params: {}
  },
  partner_list: {
    data: [],
    total: -1,
    params: {}
  },
  partner_view_children: {
    data: [],
    total: -1,
    params: {}
  },
  partner_view_affiliates: {
    data: [],
    total: -1,
    params: {}
  },
  partner_marketing_transfer_list: {
    data: [],
    total: -1,
    params: {}
  },
  partner_dashboard_list: {
    data: [],
    total: -1,
    params: {}
  }
}

export default initialState